import { useEffect, useState } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Shared layout breakpoints: keep JS and CSS in sync. */
export const BREAKPOINTS = {
  tablet: 1024,
  mobile: 768,
};

export function useIsMobile(breakpoint = BREAKPOINTS.mobile) {
  return useMediaQuery(`(max-width: ${breakpoint}px)`);
}

/** Mobile/tablet layout: matches hamburger nav breakpoint. */
export function useMobileLayout(breakpoint = BREAKPOINTS.tablet) {
  return useMediaQuery(`(max-width: ${breakpoint}px)`);
}

export function useIsTabletDown(breakpoint = BREAKPOINTS.tablet) {
  return useMediaQuery(`(max-width: ${breakpoint}px)`);
}
